<template>
  <b-row>
    <b-col>
      <LoadingLine v-if="loading && !title" width="40%" height="24px" />
      <template v-else>
        <span class="small text-muted">
          <template v-if="created">
            <b v-if="updated">{{
              $t('PAGE_playlist_updated_at', {
                date: $moment(updated).format('LL'),
              })
            }}</b>
            <b v-else>{{
              $t('PAGE_playlist_created_at', {
                date: $moment(created).format('LL'),
              })
            }}</b>
            {{ $t('PAGE_playlist_created_from', { name: physioName }) }}
          </template>
        </span>
      </template>
    </b-col>
  </b-row>
</template>

<script>
import LoadingLine from '@/elements/LoadingLine';

export default {
  name: 'ProgrammCreateUpdatenfo',
  props: {
    created: { default: null },
    updated: { default: null },
    physioName: { default: null },
    loading: { default: false },
  },

  components: {
    LoadingLine,
  },
};
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/elements/ProgrammCreateUpdateInfo.vue